<template>
  <Teleport to="body">
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal" @click.stop v-bind="$attrs">
        <div class="img-wrapper">
          <slot name="background-image"></slot>
          <img
            v-if="img && !$slots['background-image']"
            :src="require(`@/assets/${img}`)"
            alt="BG"
          />
        </div>
        <div class="wrapper">
          <div class="close" @click="closeModal">
            <Vector />
          </div>
          <div class="login-header">
            <h3>{{ name }}</h3>
          </div>
          <component :is="state.activeComponent" :state="state" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import mixin, {
  INITIAL_ERRORS,
  INITIAL_FIELDS,
} from "@/components/login/mixins"
import StartAuthorize from "./StartAuthorize.vue"
import Authorize from "./Authorize.vue"
export default defineComponent({
  name: "LoginModalMobile",
  components: {
    StartAuthorize,
    Authorize,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    img: {
      type: String,
      required: true,
    },
  },
  mixins: [mixin],
  mounted() {
    this.changeContent("StartAuthorize")
    this.state.fields = { ...INITIAL_FIELDS }
    this.state.errors = { ...INITIAL_ERRORS }
  },
})
</script>
<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(12px);

  padding: 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .modal {
    display: flex;
    position: relative;
    max-width: min(800px, 100%);
    padding: 32px;
    box-sizing: border-box;
    background: #212429;
    box-shadow: var(--black-shadow);
    border-radius: 24px;
    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 16px;
      align-items: center;
      justify-content: flex-end;
      padding-top: 60px;
      z-index: 1;
      width: 100%;
      text-align: center;
      .modal-header {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }
    }

    h3 {
      margin: 0 auto;
      font-family: "Druk Text Wide Cyr";
      font-style: normal;
      font-weight: 900;
      font-size: 40px;
      line-height: 48px;
      color: #ffffff;
    }

    .img-wrapper {
      border-radius: 24px;
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      height: 500px;
      overflow: hidden;
      z-index: 0;

      img {
        width: 100%;
      }

      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;

        background: linear-gradient(
          180deg,
          rgba(33, 36, 41, 0) 34.77%,
          rgba(33, 36, 41, 0.878157) 49.02%,
          #212429 0.52%
        );
      }

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
      }
    }

    h3 {
      font-family: "Druk Text Wide Cyr";
      font-size: 32px;
      font-weight: 1000;
      color: #ffffff;
      text-align: center;
    }

    .close {
      cursor: pointer;
      position: absolute;
      width: 20px;
      height: 20px;
      right: 24px;
      top: 24px;
    }
  }
}
</style>
